import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsVersionsRoute: InvariantJiraRoute = {
	name: 'project-settings-versions',
	path: '/plugins/servlet/project-config/:projectKey/administer-versions',
};
